/**
 * @overview Helpers to make creation and dispatching of events a breeze!
 *
 * @module eventHelper
 */

/**
 * Kill scrolling on the passed element
 *
 * @param {string} selector
 *
 * @example
 * killScroll('.mm-modal')
 *
 * @see {@link https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi|Stack Overflow}
 */
export function killScroll (selector) {

    var _overlay = document.querySelector(selector);
    var _clientY = null; // remember Y position on touch start

    console.log(_overlay);

    if (_overlay !== null) {

        _overlay.addEventListener('touchstart', (event) => {
            if (event.targetTouches.length === 1) {
                // detect single touch
                _clientY = event.targetTouches[0].clientY;
            }
        }, false);

        _overlay.addEventListener('touchmove', (event) => {
            if (event.targetTouches.length === 1) {
                // detect single touch
                disableRubberBand(event);
            }
        }, false);

    }

    function disableRubberBand (event) {
        var clientY = event.targetTouches[0].clientY - _clientY;

        if (_overlay.scrollTop === 0 && clientY > 0) {
            // element is at the top of its scroll
            event.preventDefault();
        }

        if (isOverlayTotallyScrolled() && clientY < 0) {
            //element is at the top of its scroll
            event.preventDefault();
        }
    }

    function isOverlayTotallyScrolled () {
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
        return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
    }
}
